import { Maybe } from 'maybe-not';
import MessageBus from '../utility/message-bus';

export default function shareText(messageBus: MessageBus, platformCapabilities: Set<string>) {
    if (!platformCapabilities.has('shareText')) {
        return;
    }

    return function(text: string, title?: string): Promise<void> {
        const argTitle = title || text;
        return messageBus
            .sendRequest<{ status: boolean }>(
                `executeDynamicPlatformAPI`,
                Maybe.just({ functionName: 'shareText', args: [text, argTitle] }).map(
                    JSON.stringify
                )
            )
            .then(response => {
                if (response.value.status) {
                    return;
                }
                throw new Error('shareText failed');
            });
    };
}
